<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-grey1">
    <h3 class="rs-tit6">{{ 'password.recovery.method.title' | translate }}</h3>
    <p>{{ 'password.recovery.method.description' | translate }}</p>
    <div>
      <px-alert
        *ngIf="alerts$ | async"
        [alerts]="alerts$ | async"
        (onCloseAlert)="onCloseAlert($event)"
      ></px-alert>
      <mprd-no-recovery-methods-container
        *ngIf="hasNoRecoveryMethods"
      ></mprd-no-recovery-methods-container>

      <span *ngIf="!hasNoRecoveryMethods">
        <span class="columns small-12 medium-6">
          <!-- If there is currently no SMS recovery -->
          <mprd-mobile-add-container *ngIf="showMobileAddContainer"></mprd-mobile-add-container>
          <!-- If the SMS recovery is pending -->
          <mprd-mobile-pending-container
            *ngIf="smsStatus === 'pending'"
          ></mprd-mobile-pending-container>
          <!-- If the SMS recovery is active -->
          <mprd-mobile-active-container
            *ngIf="smsStatus === 'active'"
          ></mprd-mobile-active-container>
        </span>

        <span class="columns small-12 medium-6">
          <!-- If there is currently no email recovery -->
          <mprd-email-add-container *ngIf="showEmailAddContainer"></mprd-email-add-container>
          <!-- If the email recovery is pending -->
          <mprd-email-pending-container
            *ngIf="emailStatus === 'pending'"
          ></mprd-email-pending-container>
          <!-- If the email recovery is active -->
          <mprd-email-active-container
            *ngIf="showEmailActiveContainer"
          ></mprd-email-active-container>
        </span>
      </span>

      <div *ngIf="loading$ | async" class="text-center">
        <px-loading-spinner></px-loading-spinner>
      </div>
    </div>
  </div>
</div>
